import React, { useEffect, useState } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import Loader from '../../components/Loader/Loader';
import moment from 'moment';
import Wrapper from '../Wrapper';
import axios from 'axios';

const TeacherStudents = () => {
  const { id } = useParams();
  const [isLoading, setLoading] = useState(false);
  const [students, setStudents] = useState([]);

  console.log(students);
  const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

  const [isSlipModalOpen, setIsSlipModalOpen] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const teacherName = queryParams.get('name');

  useEffect(() => {
    fetchAllStudentInCourse(id);
  }, [id]);

  const fetchAllStudentInCourse = async (courseId) => {
    setLoading(true);
    try {
      const res = await axios.get(
        `https://quran-backend-theta.vercel.app/v1/teacher/my-students/${id}?page=${currentPage}&limit=6`
      );

      console.log(res);

     
      if (result?.data.data && Array.isArray(result?.data?.data)) {
        setStudents(res?.data?.data);
       
        setTotalPages(result?.totalPages || Math.ceil(result?.totalStudents / 6) || 1);
      } else {
        setStudents([]);
        setTotalPages(1);
      }
    } catch (err) {
      console.error('Error fetching students:', err);
    } finally {
      setLoading(false);
    }
  };



  const handleChangeStatus = async (newStatus, studentId) => {
    setStudents((prevStudents) =>
      prevStudents.map((student) =>
        student.enrollment?._id === studentId ? { ...student, isLoading: true } : student
      )
    );

    try {
      const res = await axios.patch(
        `https://quran-backend-theta.vercel.app/v1/admin/update-enrollment-status/${studentId}`,
        {
          newStatus: newStatus
        }
      );

      if (res.data.success) {
        setStudents((prevStudents) =>
          prevStudents.map((student) =>
            student?.enrollment?._id === studentId
              ? { ...student, status: newStatus, isLoading: false }
              : student
          )
        );

        fetchAllStudentInCourse();
      } else {
        console.error(res.data.message);
      }
    } catch (error) {
      console.error('Error updating status:', error);
    } finally {
      setStudents((prevStudents) =>
        prevStudents.map((student) =>
          student?.enrollment?._id === studentId ? { ...student, isLoading: false } : student
        )
      );
    }
  };

  const openModal = (student) => {
    setSelectedStudent(student);
    setIsSlipModalOpen(true);
  };

  const closeModal = () => {
    setIsSlipModalOpen(false);
    setSelectedStudent(null);
  };

  const ApproveFee = async (student) => {
    // Implement the logic to approve the fee slip
    console.log('Approving fee for:', student);
    closeModal();
  };

  return (
    <Wrapper>
      <div>
        <h2 className="main_title">{teacherName}</h2>
        <p className="text-[#1C1D1D]">Here overview of the teachers</p>
      </div>

      <section className="mb-20 mt-7">
        <div className="rounded-lg overflow-x-auto">
          {isLoading ? (
            <Loader />
          ) : students && students.length > 0 ? (
            <div className="flex flex-col">
              <div className="sm:-mx-6 lg:-mx-8">
                <div className="inline-block min-w-full sm:px-6 lg:px-8">
                  <div className="overflow-hidden">
                    <table className="min-w-full mb-0">
                      <thead>
                        <tr className="rounded-lg whitespace-nowrap">
                          <th className="text-sm text-primary font-bold px-6 py-4">Sr No.</th>
                          <th className="text-sm text-primary font-bold px-6 py-4">ID</th>
                          <th className="text-sm text-primary font-bold px-6 py-4">Name</th>
                          <th className="text-sm text-primary font-bold px-6 py-4">Father Name</th>
                          <th className="text-sm text-primary font-bold px-6 py-4">Phone no</th>
                          <th className="text-sm text-primary font-bold px-6 py-4">Country</th>
                          <th className="text-sm text-primary font-bold px-6 py-4">Course</th>
                          <th className="text-sm text-primary font-bold px-6 py-4">Timing</th>
                          <th className="text-sm text-primary font-bold px-6 py-4">Payment</th>
                          <th className="text-sm text-primary font-bold px-6 py-4">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {students.map((student, index) => (
                          <tr
                            key={student._id}
                            style={{ boxShadow: '0px 0px 63.44px 0px #00000012' }}
                            className="bg-white border-b-8 border-white rounded-md"
                          >
                             <td className="align-middle bg-white text-sm font-normal px-6 py-3 whitespace-nowrap text-center">
                              <span className="bg-white text-base text-black py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline bg-green-200 rounded-full">
                                {`${index+1}`}
                              </span>
                            </td>
                           
                            <td className="align-middle bg-white text-sm font-normal px-6 py-3 whitespace-nowrap text-center">
                              <span className="bg-white text-base text-black py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline bg-green-200 rounded-full">
                                {student?.enrollment?.userDetails?.studentId}
                              </span>
                            </td>
                            <td className="text-sm bg-white font-normal text-center px-6 py-4 whitespace-nowrap">
                              <Link
                                to={`/student-details/${student.enrollment.course}/${student.enrollment.email}`}
                                className="text-base text-secondary py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline bg-green-200 rounded-full"
                              >
                                {student.enrollment.studentName}
                              </Link>
                            </td>
                            <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap">
                              <span className="text-base text-black py-1 px-2.5 leading-none whitespace-nowrap bg-green-200 rounded-full">
                                {student.enrollment.fatherName}
                              </span>
                            </td>
                            <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap">
                              <span className="text-base text-black py-1 px-2.5 leading-none whitespace-nowrap bg-green-200 rounded-full">
                                {student.enrollment.number}
                              </span>
                            </td>
                            <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap">
                              <span className="text-base text-black py-1 px-2.5 leading-none whitespace-nowrap bg-green-200 rounded-full">
                                {student.enrollment.country}
                              </span>
                            </td>
                            <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap">
                              <span className="text-base text-black py-1 px-2.5 leading-none whitespace-nowrap bg-green-200 rounded-full">
                                {student.enrollment.courseName}
                              </span>
                            </td>
                            <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap">
                              <span className="text-base text-black py-1 px-2.5 leading-none whitespace-nowrap bg-green-200 rounded-full">
                                {student.timeSlots.map((item, index) => (
                                  <div key={index}>
                                    {item.startTime} - {item.endTime}
                                  </div>
                                ))}
                              </span>
                            </td>
                            <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap">
                              {student.enrollment.paymentStatus === 'pending' ? (
                                <span className="text-base text-secondary py-1 px-2.5 leading-none whitespace-nowrap">
                                  {student.enrollment.nextPaymentDate
                                    ? moment(student.enrollment.nextPaymentDate).format('MMM Do YY')
                                    : 'N/A'}
                                </span>
                              ) : student.enrollment.paymentStatus === 'paid' ? (
                                (() => {
                                  const slipPayDate = moment(student?.feeStatus?.slipPayDate);
                                  const nextPaymentDate = moment(student?.nextPaymentDate);
                                  const diffDays = nextPaymentDate.diff(slipPayDate, 'days');

                                  return (
                                    <span
                                      style={{ color: diffDays > 30 ? 'red' : 'inherit' }}
                                      className="text-base"
                                    >
                                      {moment(student.nextPaymentDate).format('MMM Do YY')}
                                    </span>
                                  );
                                })()
                              ) : (
                                <a
                                  onClick={() => openModal(student)}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="text-base text-[#FF7E00] cursor-pointer"
                                >
                                  Approve Fee Slip
                                </a>
                              )}
                            </td>

                            <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap">
                              {student?.isLoading ? (
                                <span className="ml-2 text-gray-500">Loading...</span>
                              ) : (
                                <select
                                  className={`px-3 py-2 rounded-md ${
                                    student?.enrollment?.status === 'approved'
                                      ? 'bg-[#DFF7E3] text-[#23A118]'
                                      : student?.enrollment?.status === 'inactive'
                                        ? 'bg-[#FFF5CC] text-[#E6A800]'
                                        : 'bg-[#FCE8E6] text-[red]'
                                  }`}
                                  value={student?.enrollment?.status}
                                  onChange={(e) =>
                                    handleChangeStatus(e.target.value, student?.enrollment?._id)
                                  }
                                >
                                  <option value="pending">Pending</option>
                                  <option value="approved">Approved</option>
                                  <option value="inactive">Inactive</option>
                                </select>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <p>No students found.</p>
          )}
        </div>

        <div className="flex justify-end mt-4 items-center">
  <button
    onClick={() => handlePageChange(currentPage - 1)}
    disabled={currentPage === 1}
    className="px-4 py-2 bg-gray-200 text-gray-700 cursor-pointer rounded hover:bg-gray-300"
  >
    Previous
  </button>
  
  <span className="mx-4 py-2">
    Page {currentPage} of {totalPages}
  </span>
  
  <select
    value={currentPage}
    onChange={(e) => handlePageChange(Number(e.target.value))}
    className="mx-2 px-3 py-2 border rounded bg-white"
  >
    {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
      <option key={page} value={page}>
        {page}
      </option>
    ))}
  </select>
  
  <button
    onClick={() => handlePageChange(currentPage + 1)}
    disabled={currentPage === totalPages}
    className="px-4 py-2 bg-gray-200 text-gray-700 cursor-pointer rounded hover:bg-gray-300"
  >
    Next
  </button>
</div>
      </section>

      {isSlipModalOpen && selectedStudent && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
          onClick={closeModal}
        >
          <div
            className="bg-white p-6 rounded shadow-lg max-w-xl w-full relative"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={closeModal}
              className="absolute top-2 right-2 text-gray-500 hover:text-red-500"
            >
              ✕
            </button>

            <h2 className="text-lg font-bold mb-4">Fee Slip</h2>

            <img
              src={selectedStudent.feeStatus.slipUrl}
              alt="Fee Slip"
              className="w-full h-auto rounded mb-4"
            />

            <div className="flex justify-end gap-4">
              <button
                onClick={closeModal}
                className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
              >
                Cancel
              </button>

              <button
                onClick={() => ApproveFee(selectedStudent)}
                className="px-4 py-2 bg-[#FF7E00] text-white rounded"
              >
                Approve
              </button>
            </div>
          </div>
        </div>
      )}
    </Wrapper>
  );
};

export default TeacherStudents;
